import * as actions from './customerStories.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { CustomerStoryModel } from '@smarttask-common/src/lib/models/Prismic/CustomerStory/CustomerStoryModel';

export const customerStoryAdapter = createEntityAdapter<CustomerStoryModel>({
    selectId: (x) => x.uid,
});
export interface CustomerStoryState extends EntityState<CustomerStoryModel> {
    selected_customer_story_uid: string;
}

export const initialState: CustomerStoryState = customerStoryAdapter.getInitialState({
    selected_customer_story_uid: undefined,
});

export function CustomerStoryReducers(state: CustomerStoryState = initialState, action: actions.CustomerStoryActions) {
    switch (action.type) {
        case actions.CustomerStoryActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_customer_story_uid: action.selected_customer_story_uid };
            return state;

        case actions.CustomerStoryActionTypes.ADD_CUSTOMER_STORY:
            return customerStoryAdapter.addOne(action.customer_story, state);

        case actions.CustomerStoryActionTypes.ADD_CUSTOMER_STORIES:
            return customerStoryAdapter.addMany(action.customer_stories, state);

        case actions.CustomerStoryActionTypes.UPSERT_CUSTOMER_STORY:
            return customerStoryAdapter.upsertOne(action.customer_story, state);

        case actions.CustomerStoryActionTypes.UPSERT_CUSTOMER_STORIES:
            return customerStoryAdapter.upsertMany(action.customer_stories, state);

        case actions.CustomerStoryActionTypes.UPDATE_CUSTOMER_STORY:
            return customerStoryAdapter.updateOne(action.customer_story, state);

        case actions.CustomerStoryActionTypes.UPDATE_CUSTOMER_STORIES:
            return customerStoryAdapter.updateMany(action.customer_stories, state);

        case actions.CustomerStoryActionTypes.DELETE_CUSTOMER_STORY:
            // if(state.selectedCustomerStoryId == action.uid){
            //   state.selectedCustomerStoryId = undefined;
            // }
            return customerStoryAdapter.removeOne(action.uid, state);

        case actions.CustomerStoryActionTypes.DELETE_CUSTOMER_STORIES:
            // if(action.ids.indexOf(state.selectedCustomerStoryId) > -1){
            //   state.selectedCustomerStoryId = undefined;
            // }
            return customerStoryAdapter.removeMany(action.uids, state);

        case actions.CustomerStoryActionTypes.DELETE_ALL_CUSTOMER_STORIES:
            return customerStoryAdapter.removeMany(action.uids, state);

        case actions.CustomerStoryActionTypes.DELETE_ALL:
            return customerStoryAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getCustomerStoryState = createFeatureSelector<CustomerStoryState>('customerStory');

export const { selectIds, selectEntities, selectAll, selectTotal } = customerStoryAdapter.getSelectors(getCustomerStoryState);

const getSelectedCustomerStoryIdState = (state: CustomerStoryState) => {
    return state.selected_customer_story_uid;
};
export const getSelectedCustomerStoryId = createSelector(getCustomerStoryState, getSelectedCustomerStoryIdState);

export const getSelectedCustomerStory = createSelector(getCustomerStoryState, (state: CustomerStoryState) => {
    if (state.selected_customer_story_uid == undefined) {
        return undefined;
    }
    return state.entities[state.selected_customer_story_uid];
});
